import SearchInput from "@components/ui/searchInput";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useEffect, useRef, useState } from "react";
import useAuth from "@hooks/useAuth";
import {
  getAllTargetMarkets,
  getTargetMarketsById,
  saveFilter,
  saveFiltersState,
} from "@redux/slices/filter";
import LoadingScreen from "@components/LoadingScreen";
import { ChevronLeft, Cross, Download, Pencil, X } from "lucide-react";
import { Filters } from "@/types/filters";
import DashboardFilters from "@pages/Dashboard/filters";
import EditFilters from "./editFilters/filters";
import { Button } from "@components/ui/button";
import { useDispatch } from "react-redux";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from "react-router";
const TargetMarketDetail = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [closeModal, setCloseModal] = useState(false);
  const [name, setName] = useState("");
  const [targetMarketFilters, setTargetMarketFilters] = useState<Filters>();
  const [companyFilters, setCompanyFilters] =
    useState<Filters["companyFilters"]>();
  const [contactFilters, setContactFilters] =
    useState<Filters["contactFilters"]>();
  const [keywordsSuggestions, setKeywordsSuggestions] = useState<string[]>([]);
  const [socialMedia, setSocialMedia] = useState<string[]>([]);
  const [departmentHierarchy, setDepartmentHierarchy] = useState<string[]>([]);
  const [deptSearchOptions, setDptSearchOptions] = useState<string[]>([]);
  const [jobTitleSearch, setJobTitleSearch] = useState<string[]>([]);
  const [contactLocation, setContactLocation] = useState<string[]>([]);
  const [contactSources, setContactSources] = useState<string[]>([]);
  const [contactEmail, setContactEmail] = useState<string[]>([]);
  const [contactPhone, setContactPhone] = useState<string[]>([]);
  const [softwareFilters, setSoftwareFilters] =
    useState<Filters["softwareAndSystems"]>();
  const [newsFilters, setNewsFilters] =
    useState<Filters["newsAndTriggerEvents"]>();
  const [regionalFilters, setRegionalFilters] =
    useState<Filters["regionalFilters"]>();
  const [countryFilter, setCountryFilter] = useState<string[]>([]);
  const [industries, setIndustries] = useState<Filters["industries"]>();
  const [companyProfileRequirements, setCompanyProfileRequirements] = useState<
    string[]
  >([]);
  const [companySearchOptions, setCompanySearchOptions] = useState<string[]>(
    []
  );

  const { user } = useAuth();
  const id = window.location.pathname.split("/")[3];
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const getData = async () => {
    try {
      const targetMarketsArray =
        user?.role !== "admin"
          ? await getTargetMarketsById(user?.id)
          : await getAllTargetMarkets();

      if (targetMarketsArray && targetMarketsArray.length > 0) {
        const filteredData = targetMarketsArray.filter(
          (i) => i?.id === Number(id)
        );
        setName(filteredData[0]?.name);
        if (filteredData.length > 0) {
          const parsedFilters = JSON.parse(filteredData[0]?.filters);
          setTargetMarketFilters(parsedFilters);
          dispatch(saveFilter(parsedFilters));
          setCompanyFilters(parsedFilters?.companyFilters);
          setContactFilters(parsedFilters?.contactFilters);
          setSoftwareFilters(parsedFilters?.softwareAndSystems);
          setNewsFilters(parsedFilters?.newsAndTriggerEvents);
          setRegionalFilters(parsedFilters?.regionalFilters);
          setIndustries(parsedFilters?.industries);
          // setCompanyFilters(Object.)
          console.log("filters", parsedFilters);
          setCompanySearchOptions(
            getKeysWithTrueValue(
              parsedFilters?.companyFilters?.companySearch?.searchOptions
            )
          );
          setCompanyProfileRequirements(
            getKeysWithTrueValue(
              parsedFilters?.companyFilters?.companyProfile?.requirements
            )
          );
          setKeywordsSuggestions(
            getKeysWithTrueValue(
              parsedFilters?.companyFilters?.keywordsAndTopics?.suggestions
            )
          );
          setSocialMedia(
            getKeysWithTrueValue(
              parsedFilters?.companyFilters?.companyProfile?.socialMedia
            )
          );
          setDepartmentHierarchy(
            getKeysWithTrueValue(
              parsedFilters?.contactFilters?.departmentHierarchy?.hierarchy
            )
          );
          setDptSearchOptions(
            getKeysWithTrueValue(
              parsedFilters?.contactFilters?.departmentHierarchy?.searchOptions
            )
          );
          setJobTitleSearch(
            getKeysWithTrueValue(
              parsedFilters?.contactFilters?.jobTitleSearch?.suggestions
            )
          );
          setContactLocation(
            getKeysWithTrueValue(parsedFilters?.contactFilters?.contactLocation)
          );
          setContactSources(
            getKeysWithTrueValue(
              parsedFilters?.contactFilters?.contactProfile?.contactSources
            )
          );
          setContactEmail(
            getKeysWithTrueValue(
              parsedFilters?.contactFilters?.contactProfile?.emailAddress
            )
          );
          setContactPhone(
            getKeysWithTrueValue(
              parsedFilters?.contactFilters?.contactProfile?.phoneNumber
            )
          );
          setCountryFilter(
            getKeysWithTrueValue(parsedFilters?.regionalFilters?.countryFilter)
          );

          console.log(parsedFilters?.softwareAndSystems);
        } else {
          console.error("No matching data found for the provided ID");
        }
      } else {
        console.error("No data found for the user or error occurred");
      }
    } catch (error) {
      console.error("An error occurred while fetching the data:", error);
    } finally {
      setLoading(false);
    }
  };
  const getKeysWithTrueValue = (obj: any) => {
    if (!obj || typeof obj !== "object") {
      return [];
    }
    return Object?.entries(obj)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key);
  };
  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setLoading(true);
    getData();
    setShowModal(false);
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    let yPosition = 10;
    const pageHeight = doc.internal.pageSize.height;
  
    // Helper function to add styled text
    const addText = (text:any, fontSize = 12, color:[number,number,number] = [0, 0, 0], isBold = false) => {
      doc.setTextColor(...color);
      doc.setFontSize(fontSize);
      if (isBold) {
        doc.setFont("helvetica", "bold");
      } else {
        doc.setFont("helvetica", "normal");
      }
      doc.text(text, 10, yPosition);
      yPosition += fontSize + 2; // Increase space after text
      if (yPosition > pageHeight - 20) {
        doc.addPage();
        yPosition = 10;
      }
    };
  
    // Helper function to add a section with a title and content
    const addSection = (title:string, content:any, titleColor:[number,number,number] = [0, 102, 204], contentColor:[number,number,number] = [0, 0, 0]) => {
      addText(title, 14, titleColor, true);
      content.forEach((line:any) => {
        addText(line, 12, contentColor);
      });
      yPosition += 5; // Add extra space after section
    };
  
    // Company Search Section
    if (companyFilters?.companySearch) {
      const searchKeywords = companyFilters.companySearch.searchKeywords || ["No keywords found"];
      addSection("Company Search - Keywords", searchKeywords);
      const searchOptions = companySearchOptions || ["No options found"];
      addSection("Company Search - Options", searchOptions);
    }
  
    // Company Size Section
    if (companyFilters?.companySize) {
      const companySizeInfo = [
        `From: ${companyFilters.companySize.from || "N/A"} - To: ${companyFilters.companySize.to || "N/A"}`,
        `Unknown Size: ${companyFilters.companySize.unknownSize ? "True" : "False"}`
      ];
      addSection("Company Size", companySizeInfo);
    }
  
    // Keywords and Topics Section
    if (companyFilters?.keywordsAndTopics) {
      const keywords = companyFilters.keywordsAndTopics.searchKeywords || ["No keywords found"];
      addSection("Keywords and Topics", keywords);
      const suggestions = keywordsSuggestions || ["No suggestions found"];
      addSection("Suggestions", suggestions);
    }
  
    // Website Content Section
    if (companyFilters?.websiteContent) {
      const websiteKeywords = companyFilters.websiteContent.searchKeywords || ["No keywords found"];
      addSection("Website Content - Keywords", websiteKeywords);
    }
  
    // Contact Filters Section
    if (departmentHierarchy) {
      const deptHierarchy = departmentHierarchy || ["No departments found"];
      addSection("Contact Filters - Department Hierarchy", deptHierarchy);
    }
  
    if (jobTitleSearch) {
      const jobTitles = jobTitleSearch || ["No job titles found"];
      addSection("Job Title Search", jobTitles);
    }
  
    // Contact Profile Section
    addSection("Contact Profile - Sources", contactSources || ["No contact sources found"]);
    addSection("Email Addresses", contactEmail || ["No email addresses found"]);
    addSection("Phone Numbers", contactPhone || ["No phone numbers found"]);
  
    // Software & Systems Section
    if (softwareFilters) {
      const softwareSystems = softwareFilters.softwareSystems || ["No software systems found"];
      addSection("Software & Systems", softwareSystems);
      addText(`Include Unknown Shop Systems: ${softwareFilters.includeUnknownShopSystem ? "True" : "False"}`, 12, [100, 100, 100]);
    }
  
    // Industries Section
    if (industries) {
      const selectedIndustries = industries.selectedIndustries || ["No selected industries found"];
      addSection("Industries - Selected", selectedIndustries);
      const naceCodes = industries.naceCodes || ["No NACE codes found"];
      addSection("Industries - NACE Codes", naceCodes);
      const wzCodes = industries.wzCodes || ["No WZ codes found"];
      addSection("Industries - WZ Codes", wzCodes);
    }
  
    // Regional Filters Section
    addSection("Regional Filters - Country Filter", countryFilter?.length ? countryFilter : ["No countries found"]);
  
    if (regionalFilters) {
      addSection("Regional Filters - Radius", [
        `Location: ${regionalFilters.radius?.location || "N/A"}`,
        `Radius: ${regionalFilters.radius?.radius || "N/A"}`,
      ]);
    }
  
    // News & Trigger Events Section
    if (newsFilters) {
      const events = newsFilters.events?.length ? newsFilters.events : ["No events found"];
      addSection("News & Trigger Events - Events", events);
      addSection("News & Trigger Events - Event Date", [
        newsFilters.eventDate || "N/A",
        `Publication Period: ${newsFilters.publicationPeriod || "N/A"}`,
        `Search Criteria: ${newsFilters.searchCriteria || "N/A"}`,
      ]);
    }
  
    // Financial Filters Section
    if (targetMarketFilters?.financialFigures) {
      addSection("Financial Filters - Financial Figures", [
        `Revenue: ${targetMarketFilters.financialFigures.from} - ${targetMarketFilters.financialFigures.to}`,
        `Currency: ${targetMarketFilters.financialFigures.currency || "N/A"}`,
        `Revenue Unknown: ${targetMarketFilters.financialFigures.unknownSize ? "True" : "False"}`,
      ]);
    }
  
    // Save the PDF
    doc.save("filters.pdf");
  };
  

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="md:flex justify-between items-center my-7">
            <h2 className="text-gray font-bold flex items-center sm:text-[22px] text-lg capitalize md:mb-0 mb-4">
              <ChevronLeft
                size={22}
                className="me-3 cursor-pointer"
                onClick={() => navigate(-1)}
              />
              {name !== "" ? name : "TM " + id}
            </h2>
            <div className="flex justify-between items-center">
              <SearchInput />
              {user?.role == "admin" && (
                <Button
                  variant="secondary"
                  className="me-2 bg-white"
                  onClick={generatePDF}
                >
                  <Download size={20} className="me-2" />
                  Export
                </Button>
              )}
              {user?.role !== "admin" && (
                <Button
                  className="ms-2"
                  onClick={() => {
                    handleOpenModal();
                  }}
                >
                  <Pencil size={16} className="me-2" />
                  Edit
                </Button>
              )}
            </div>
          </div>
          <div className="bg-white rounded-lg p-8">
            <Accordion type="single" collapsible>
              <AccordionItem value="item-1">
                <AccordionTrigger>Company Filters</AccordionTrigger>
                <AccordionContent>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">Company Search</h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 pt-2 pb-3 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                          onClick={() => {
                            handleOpenModal();
                          }}
                        /> */}
                        Search Keywords
                        <div>
                          {companyFilters?.companySearch?.searchKeywords?.map(
                            (val, ind) => {
                              return (
                                <span className="text-xs text-zinc-500">
                                  {val},{" "}
                                </span>
                              );
                            }
                          )}
                        </div>
                      </div>
                      <div className="bg-white px-3 pt-2 pb-3 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Search Options</h5>
                        {companySearchOptions?.map((val, ind) => {
                          return (
                            <span className="text-xs text-zinc-500 mt-2 capitalize">
                              {val},{" "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">Company Size</h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Suggestions</h5>

                        <p className="text-xs text-zinc-500">
                          {companyFilters?.companySize?.from +
                            " - " +
                            companyFilters?.companySize?.to}
                        </p>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Unknwon Company Size</h5>

                        <p className="text-xs text-zinc-500">
                          {companyFilters?.companySize?.unknownSize
                            ? "True"
                            : "False"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">
                      Keywords and Topics
                    </h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Keyword Match</h5>

                        <p className="text-xs text-zinc-500 mt-1 capitalize">
                          {companyFilters?.keywordsAndTopics?.keywordMatch}
                        </p>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Search Keywords
                        <div>
                          {companyFilters?.keywordsAndTopics?.searchKeywords?.map(
                            (val, ind) => {
                              return (
                                <span className="text-xs text-zinc-500">
                                  {val},{" "}
                                </span>
                              );
                            }
                          )}
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative mt-2">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Suggestions</h5>
                        {keywordsSuggestions?.map((val, ind) => {
                          return (
                            <span className="text-xs text-zinc-500 mt-2 capitalize">
                              {val},{" "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">Website Content</h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Search Keywords
                        <div className="mt-1">
                          {companyFilters?.websiteContent?.searchKeywords?.map(
                            (val, ind) => {
                              return (
                                <span className="text-xs text-zinc-500">
                                  {val},{" "}
                                </span>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">Company Profile</h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Data Completeness</h5>

                        <p className="text-xs text-zinc-500 mt-1 capitalize">
                          {companyFilters?.companyProfile?.dataCompleteness}
                        </p>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Requirements
                        <div className="mt-1">
                          {companyProfileRequirements?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative mt-2">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Social Media</h5>
                        {socialMedia?.map((val, ind) => {
                          return (
                            <span className="text-xs text-zinc-500 mt-2 capitalize">
                              {val},{" "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger>Contact Filters</AccordionTrigger>
                <AccordionContent>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">
                      Department Hierarachy
                    </h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Hierarchy</h5>
                        <div className="mt-1">
                          {departmentHierarchy?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Search options</h5>
                        {deptSearchOptions?.map((val, ind) => {
                          return (
                            <span className="text-xs text-zinc-500 mt-2 capitalize">
                              {val},{" "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">Job Title Search</h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Suggestions</h5>
                        <div className="mt-1">
                          {jobTitleSearch?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">
                      Contact Locations
                    </h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        {/* <h5 className="font-medium">

                        Suggestions
                        </h5> */}
                        <div className="mt-1">
                          {contactLocation?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">Contact Profile</h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Contact Sources
                        <div className="mt-1">
                          {contactSources?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Email Address
                        <div className="mt-1">
                          {contactEmail?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative mt-2">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Phone Number</h5>
                        {contactPhone?.map((val, ind) => {
                          return (
                            <span className="text-xs text-zinc-500 mt-2 capitalize">
                              {val},{" "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger>Software & Systems</AccordionTrigger>
                <AccordionContent>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Software Systems
                        <div className="mt-1">
                          {softwareFilters?.softwareSystems?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Include Unknown Shop Systems
                        <div className="mt-1">
                          <span className="text-xs text-zinc-500 capitalize font-normal">
                            {softwareFilters?.includeUnknownShopSystem === true
                              ? "true"
                              : "false"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-4">
                <AccordionTrigger>Industries</AccordionTrigger>
                <AccordionContent>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Selected Industries
                        <div className="mt-1">
                          {industries?.selectedIndustries?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500 font-normal">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        NACE Codes
                        <div className="mt-1">
                          {industries?.naceCodes?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500 font-normal">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium mt-2">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        WZ Codes
                        <div className="mt-1">
                          {industries?.wzCodes?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500 font-normal">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-5">
                <AccordionTrigger>Regional Filters</AccordionTrigger>
                <AccordionContent>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">Country Filter</h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Countries</h5>
                        <div className="mt-1">
                          {countryFilter?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">Radius</h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Location
                        <div className="mt-1">
                          <span className="text-xs text-zinc-500 capitalize font-normal">
                            {regionalFilters?.radius?.location}
                          </span>
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium ">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Radius
                        <div className="mt-1">
                          <span className="text-xs text-zinc-500 capitalize font-normal">
                            {regionalFilters?.radius?.radius}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-6">
                <AccordionTrigger>News & Trigger Events</AccordionTrigger>
                <AccordionContent>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Events
                        <div className="mt-1">
                          {newsFilters?.events?.map((val, ind) => {
                            return (
                              <span className="text-xs text-zinc-500 font-normal">
                                {val},{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Event Date
                        <div className="mt-1">
                          <span className="text-xs text-zinc-500 capitalize font-normal">
                            {newsFilters?.eventDate}
                          </span>
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium mt-2">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Publication Period
                        <div className="mt-1">
                          <span className="text-xs text-zinc-500 capitalize font-normal">
                            {newsFilters?.publicationPeriod}
                          </span>
                        </div>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative font-medium mt-2">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        Search Criteria
                        <div className="mt-1">
                          <span className="text-xs text-zinc-500 capitalize font-normal">
                            {newsFilters?.searchCriteria}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-7">
                <AccordionTrigger>Finanacial Filters</AccordionTrigger>
                <AccordionContent>
                  <div className="bg-[#F4F4F4] rounded-sm p-4 m-2 relative ">
                    {/* <div className="cursor-pointer absolute right-4 top-5 text-xs text-red-500">
                      Edit
                    </div> */}
                    <h5 className="capitalize font-medium">
                      Financial Figures
                    </h5>
                    <div className="flex flex-wrap mt-3 text-[#71717A]">
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Revenue</h5>

                        <p className="text-xs text-zinc-500">
                          {targetMarketFilters?.financialFigures?.from +
                            " - " +
                            targetMarketFilters?.financialFigures?.to}
                        </p>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Currency</h5>

                        <p className="text-xs text-zinc-500">
                          {targetMarketFilters?.financialFigures?.currency}
                        </p>
                      </div>
                      <div className="bg-white px-3 py-2 rounded-sm w-1/3 me-2 relative">
                        {/* <X
                          className="cursor-pointer absolute right-3 top-3"
                          size={14}
                        /> */}
                        {/* <Pencil
                          size={16}
                          className="cursor-pointer absolute right-3 top-3"
                        /> */}
                        <h5 className="font-medium">Revenue Unknown</h5>

                        <p className="text-xs text-zinc-500">
                          {targetMarketFilters?.financialFigures?.unknownSize
                            ? "True"
                            : "False"}
                        </p>
                      </div>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
          <EditFilters
            handleCloseModal={handleCloseModal}
            showModal={showModal}
            setCloseModal={setCloseModal}
            id={Number(id)}
            filtersData={targetMarketFilters}
          />
        </div>
      )}
    </>
  );
};

export default TargetMarketDetail;
